import { gql } from '@apollo/client'
import { PersistentAlertBannerType } from '@jusbrasil-web/shared-apollo-client/types'

import { PersistentAlertBannerQuery } from './__generated__/query.graphql'
import { JusbrasilExperienceAlert, JusIAAlert, SubscriptionOverdue } from './components'

export type ServerSidePersistentAlertBannerProps = {
  persistentAlertBannerViewer: PersistentAlertBannerQuery['root']['persistentAlertBannerViewer']
}

export function ServerSidePersistentAlertBanner({
  persistentAlertBannerViewer,
}: ServerSidePersistentAlertBannerProps) {
  const ComponentMap: Partial<Record<PersistentAlertBannerType, React.ElementType>> = {
    OVERDUE_SUBSCRIPTION: SubscriptionOverdue,
    JUS_IA: JusIAAlert,
    JUSBRASIL_EXPERIENCE: JusbrasilExperienceAlert,
  }

  const Component = ComponentMap[persistentAlertBannerViewer?.type as keyof typeof ComponentMap]

  if (!Component || !persistentAlertBannerViewer?.type) {
    return null
  }

  return <Component {...persistentAlertBannerViewer} />
}

ServerSidePersistentAlertBanner.fragments = {
  root: gql`
    fragment ServerSidePersistentAlertBanner_root on RootApi {
      persistentAlertBannerViewer(appPageId: $appPageId) {
        type
        text
        icon {
          type
        }
        link {
          url
          label
        }
      }
    }
  `,
}
